import { graphql } from "gql.tada";
import { PartnershipListItemFragment } from "../fragments/PartnershipListItemFragment";

export const PartnershipListSectionById = graphql(
  `
    query PartnershipListSectionById(
      $locale: String
      $preview: Boolean
      $id: String!
      $skip: Int
    ) {
      partnershipListSection(id: $id, preview: $preview, locale: $locale) {
        ...PartnershipListFragment
      }
    }

    fragment PartnershipListFragment on PartnershipListSection {
      _id
      itemsCollection(skip: $skip, limit: 5) {
        items {
          ...PartnershipListItemFragment
        }
        total
      }
      viewMoreText
    }
  `,
  [PartnershipListItemFragment]
);
